import {
  customType,
  extend,
  namedFragment,
  params,
  string as stringType,
} from '@thd-nucleus/data-sources';
import { SponsoredBanner as SponsoredBannerComponent } from '@thd-olt-component-react/sponsored-content';
import { Section, SponsoredBanner } from './dataModelFragments';
import { COMPONENT_CLASS } from '../constants';

const bentoHeroDataModel = extend({
  component: params({
    id: stringType().isRequired(),
    componentClass: customType(COMPONENT_CLASS).enum(['BentoHero']).isRequired(),
  }).shape({
    BentoHero: namedFragment({
      inline: true,
      fragmentType: 'BentoHero',
      fragmentAlias: 'BentoHeroHomeV1'
    }).shape({
      id: stringType(),
      componentName: stringType(),
      customRenderId: stringType(),
      firstBay: Section,
      secondBay: Section,
      thirdBay: Section,
      fourthBay: Section,
      bentoSponsoredBanner: SponsoredBanner,
      theme: stringType(),
    }),
  }),
}, SponsoredBannerComponent);

export { bentoHeroDataModel };
